module.exports = __webpack_public_path__ + "img/session2_card_icon2.74f8b549.png";